class MyURLSearchParams {
    constructor(init) {
        this.params = {};
        if (typeof init === 'string') {
            this.parse(init);
        }
        else if (init && typeof init === 'object') {
            for (const key in init) {
                if (Object.prototype.hasOwnProperty.call(init, key)) {
                    this.append(key, init[key]);
                }
            }
        }
    }
    parse(str) {
        const params = str.split('&');
        params.forEach((param) => {
            const [key, value] = param.split('=').map(decodeURIComponent);
            this.append(key, value);
        });
    }
    append(key, value) {
        if (this.params[key]) {
            this.params[key] = this.params[key].concat([value]);
        }
        else {
            this.params[key] = [value];
        }
    }
    get(key) {
        return this.params[key] ? this.params[key][0] : null;
    }
    getAll(key) {
        return this.params[key] || [];
    }
    delete(key) {
        delete this.params[key];
    }
    has(key) {
        return Object.prototype.hasOwnProperty.call(this.params, key);
    }
    set(key, value) {
        this.params[key] = [value];
    }
    toString() {
        const items = [];
        for (const key in this.params) {
            if (Object.prototype.hasOwnProperty.call(this.params, key)) {
                this.params[key].forEach((value) => {
                    items.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
                });
            }
        }
        return items.join('&');
    }
}
export default MyURLSearchParams;
